<script setup>
import Delimiter from '@sections/delimiter.vue'
import Location from '@sections/location.vue'
</script>
<template>
	<Location />
	<!-- <Delimiter /> -->
</template>
